import { Icon } from '@doxyme/icons';
import { AvatarVariant } from '../avatar.types';

export const ScreenshareAvatar: AvatarVariant = ({
  'aria-label': ariaLabel,
}) => <Icon.Screenshare size={32} aria-label={ariaLabel} />;
